import api from './api';
import {
  Inbetriebnahmeprotokoll,
  CreateProtokollRequest,
  UpdateProtokollRequest,
} from '../types';

const protokollService = {
  getAll: async (): Promise<Inbetriebnahmeprotokoll[]> => {
    const res = await api.get('/protokolle');
    return res.data;
  },

  getById: async (id: number): Promise<Inbetriebnahmeprotokoll> => {
    const res = await api.get(`/protokolle/${id}`);
    return res.data;
  },

  create: async (req: CreateProtokollRequest): Promise<Inbetriebnahmeprotokoll> => {
    const res = await api.post('/protokolle', req);
    return res.data;
  },

  update: async (id: number, req: UpdateProtokollRequest): Promise<Inbetriebnahmeprotokoll> => {
    const res = await api.put(`/protokolle/${id}`, req);
    return res.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/protokolle/${id}`);
  },

  markGelesen: async (id: number): Promise<void> => {
    await api.put(`/protokolle/${id}/gelesen`, { gelesen: true });
  },

  markUngelesen: async (id: number): Promise<void> => {
    await api.put(`/protokolle/${id}/gelesen`, { gelesen: false });
  },

  markBulkGelesen: async (ids: number[], gelesen: boolean): Promise<void> => {
    await api.post('/protokolle/bulk-gelesen', { ids, gelesen });
  },

  getUngeleseneAnzahl: async (): Promise<number> => {
    const res = await api.get('/protokolle/ungelesen-anzahl');
    return res.data.anzahl;
  },

  downloadPdf: async (id: number): Promise<void> => {
    const response = await api.get(`/protokolle/${id}/pdf`, { responseType: 'blob' });
    const contentDisposition = response.headers['content-disposition'];
    let filename = `Inbetriebnahme_${id}.pdf`;
    if (contentDisposition) {
      const match = contentDisposition.match(/filename[^;=\n]*=([^;\n]*)/);
      if (match?.[1]) filename = match[1].replace(/['"]/g, '').trim();
    }
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};

export default protokollService;
